
export const ASSETS_URL = "https://s3.us-east-2.amazonaws.com/assets.totalsolar.ph/"